<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    Lanceurs de flux
  </dxi-item>
  <dxi-item location="after">
    <yo-button
      iconClass="fas fa-cog"
      tooltip="Paramètres DOL Flow Orchestrator"
      (onClick)="configDialogVisible.set(true)">
    </yo-button>
  </dxi-item>
</dx-toolbar>

<yo-dol-flow-orchestrator-config-dialog
  [(visible)]="configDialogVisible">
</yo-dol-flow-orchestrator-config-dialog>

<div class="lanceurs-page">

  @for (provider of providerList(); track provider.providerCode) {
    <div class="provider-section" [class.provider-unavailable]="!provider.available && !provider.loading">

      <div class="provider-header">
        <div class="provider-header-left">
          <span class="provider-badge">{{ provider.providerCode }}</span>
          <div class="provider-meta">
            <span class="provider-label">{{ provider.label }}</span>
            <span class="provider-description">{{ provider.description }}</span>
          </div>
        </div>
        <div class="provider-header-right">
          <span class="provider-mode-badge">{{ provider.mode }}</span>
          @if (provider.loading) {
            <span class="loading-badge">Chargement...</span>
          }
          @if (!provider.available && !provider.loading) {
            <span class="coming-soon-badge">Synchronisation des flux indisponible</span>
          }
        </div>
      </div>

      <div class="provider-body">
        @if (provider.loading) {
          <div class="provider-loading">Chargement des webhooks disponibles...</div>
        } @else {
          @if (hasAnyDirection(provider)) {
            @for (direction of directionList; track direction) {
              @if (hasDirection(provider, direction)) {
                <div class="direction-group">
                  <div class="direction-header"
                       [class.direction-import]="direction === 'IMPORT'"
                       [class.direction-export]="direction === 'EXPORT'">
                    {{ direction === 'IMPORT' ? 'Import' : 'Export' }}
                  </div>
                  <div class="flux-grid">
                    @for (f of getFluxByDirection(provider, direction); track f.id) {
                      <ng-container [ngTemplateOutlet]="fluxCardTpl"
                                    [ngTemplateOutletContext]="{ flux: f, provider: provider, direction: direction }">
                      </ng-container>
                    }
                  </div>
                </div>
              }
            }
          } @else {
            <div class="flux-grid">
              @for (f of provider.fluxList; track f.id) {
                <ng-container [ngTemplateOutlet]="fluxCardTpl"
                              [ngTemplateOutletContext]="{ flux: f, provider: provider, direction: null }">
                </ng-container>
              }
            </div>
          }
        }
      </div>

    </div>
  }

</div>

<ng-template #fluxCardTpl let-flux="flux" let-provider="provider" let-direction="direction">
  <div class="flux-card" [class.flux-card-running]="flux.status === 'running'">

    <div class="flux-card-label">{{ flux.label }}</div>

    <div class="flux-card-action">
      <yo-button
        [theme]="direction === 'IMPORT' ? ButtonThemeEnum.SUCCESS : ButtonThemeEnum.DEFAULT"
        label="Lancer"
        [disabled]="!provider.available || flux.status === 'running'"
        (onClick)="launch(provider, flux)"
        [tooltip]="provider.available ? flux.label : 'Disponible prochainement'">
      </yo-button>
    </div>

  </div>
</ng-template>
